<script setup lang="ts">
import type { ResponsiveImageType } from "vue-datocms";
import type { ImageFileField, TrendsInspirationTagRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{
  pageId: string;
  image?: ImageFileField;
  title: string;
  text?: string;
  linkText?: string;
  linkUrl?: string;
  tags?: Array<TrendsInspirationTagRecord>;
}>();
</script>

<template>
  <div class="stretched-link-card group">
    <div class="relative">
      <div class="overflow-hidden rounded-b-2xl">
        <DatocmsImage
          v-if="image"
          :data="image.responsiveImage as ResponsiveImageType"
          object-fit="cover" class="transition-transform duration-300 ease-in-out group-hover:scale-105"
        />
      </div>

      <div v-if="tags?.at(0)" class="bottom-xs left-xs absolute">
        <UBadge variant="solid" color="primary" size="md" :ui="{ base: 'bg-white text-primary font-semibold rounded-2xl px-xs py-xs leading-4' }">
          {{ tags?.at(0)?.tag.toUpperCase() }}
        </UBadge>
      </div>
    </div>

    <div class="p-lg">
      <h5 class="mb-md">
        {{ title }}
      </h5>

      <div class="html-content">
        <div v-if="text" v-html="text" />

        <NuxtLinkLocale v-if="linkUrl" :to="`/${linkUrl}`">
          {{ linkText }}
        </NuxtLinkLocale>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
